import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { NavLink } from 'react-router-dom';
import { countryTextMap } from 'routes/Util/Util.helper';
import { SignInModal } from 'components/Modals/SignInModal';
import { UserContext } from 'components/UserContext';
import { useCallback, useContext } from 'react';
import { ModalContext } from 'components/ModalContext';

export const Header = () => {
  const { open } = useContext(ModalContext);
  const { isLoading, user } = useContext(UserContext);
  const onLoginClick = useCallback(() => {
    open(<SignInModal />);
  }, [open]);

  return (
    <header className="sticky-top bg-white border-bottom">
      <Container fluid="xl">
        <Navbar expand="sm" collapseOnSelect>
          <Navbar.Brand as={NavLink} to="/">
            InIn
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Item>
                <Nav.Link as={NavLink} to="/KR" href="/KR">
                  {countryTextMap['KR']}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={NavLink} to="/US" href="/US">
                  {countryTextMap['US']}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={NavLink} to="/ideas" href="/ideas">
                  아이디어
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  as={NavLink}
                  to="/event"
                  href="/event"
                  className="d-flex align-items-center"
                >
                  <span>이벤트</span>
                  <span className="badge bg-primary ms-1 p-1">N</span>
                </Nav.Link>
              </Nav.Item>
              {/* <Nav.Item>
                <Nav.Link as={NavLink} to="/principle" href="/principle">
                  리스크 관리
                </Nav.Link>
              </Nav.Item> */}
              <Nav.Item>
                <Nav.Link as={NavLink} to="/about" href="/about">
                  소개
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  className="nav-link"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSendaxaDr7xEdvoK5tZQNAz6TA4cAM0P_GUzY1eRIpq5BzCVw/viewform?usp=sf_link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  문의
                </Nav.Link>
              </Nav.Item>
              {user?.email === 'nscorpio16@gmail.com' && (
                <Nav.Item>
                  <Nav.Link as={NavLink} to="/admin" href="/admin">
                    어드민
                  </Nav.Link>
                </Nav.Item>
              )}
              {/* <Nav.Item>
                <Nav.Link as={NavLink} to="/settings">설정</Nav.Link>
              </Nav.Item> */}
            </Nav>
            <hr className="d-md-none"></hr>
            {!isLoading &&
              (user ? (
                <Nav>
                  <Nav.Item>
                    <Nav.Link
                      as={NavLink}
                      to="/profile"
                      href="/profile"
                      className="p-0"
                    >
                      <img
                        src={user.photoURL}
                        alt="profile"
                        className="rounded-circle border"
                        width="24"
                        height="24"
                      />
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              ) : (
                <Button variant="outline-primary" onClick={onLoginClick}>
                  로그인
                </Button>
              ))}
            <hr className="d-md-none"></hr>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </header>
  );
};
